import { Sheet } from '../components/Sheet';
import { AddMenu, ADD_MENU_SUBTITLE } from '../add/AddMenu';
import { NAV } from '../strings';

export interface AddSheetProps {
  open: boolean;
  onClose: () => void;
}

/**
 * The one add menu in the app, opened by "+ Lägg till" at the top of the
 * SideNav, by the tablet rail button and by the mobile FAB (spec section 3
 * lists the route as "/lagg-till (sheet)"). It owns no cards of its own: this
 * is the same `AddMenu` that /lagg-till renders, so the two
 * cannot drift apart again.
 */
export function AddSheet({ open, onClose }: AddSheetProps) {
  return (
    <Sheet open={open} onClose={onClose} title={NAV.add} subtitle={ADD_MENU_SUBTITLE} className="add-sheet">
      {open ? <AddMenu variant="sheet" onLeave={onClose} /> : null}
    </Sheet>
  );
}
